/**
商品列表
**/
<template>
	<div class="header_logo">
		<el-menu background-color="#ff6700" mode="horizontal" router class="el-menu-vertical-demo">
			<el-menu-item><img class="xunyouText" :src="logo" @click="$router.push('/')" alt=""></el-menu-item>
			<el-menu-item v-for="item in leftMenu" :key="item.id" :index="item.url">
				<template slot="title"><i :class="item.icon"></i>{{item.menu}}</template>
			</el-menu-item>
		</el-menu>
		<div class="middle">
			<div class="dialogContent">
				<div class="chat-box" v-loading="loadingdialog">
					<div
						style="height: 50px; line-height: 50px; font-size: 24px; text-align: center; margin-bottom: 15px;">
						{{type}}
					</div>
					<div id="message-list">
						<div style="margin: 15px 0;" v-for="(message, index) in messages" :key="index">
							<div v-if="message.messageType == 0"
								:class="message.fromId == userid ? 'rightmessage' : 'leftmessage'">
								<div class="divzt">{{message.readState == 'true' ? '已读' : '未读'}}</div>
								<div class="divimg"><img :src="message.avatar" alt="" /></div>
								<div class="divtext" v-html="textfaceimg(message.content)"></div>
							</div>
							<div v-else-if="message.messageType == 3"
								:class="message.fromId == userid ? 'rightmessage' : 'leftmessage'">
								<div class="divimg"><img :src="message.avatar" alt="" /></div>
								<div class="divzt">{{message.off == 'true' ? '已读' : '未读'}}</div>
								<div class="divtext">
									<div class="minicard">
										<div class="left"><img :src="message.extend.image" alt="" /></div>
										<div class="right">
											<span>名称：<strong>{{message.extend.goodsname}}</strong></span>
											<span>价格：<strong
													style="color:#D33A31;">￥{{message.extend.price}}</strong></span>
											<span>订单号：{{message.extend.orderNumber}}</span>
										</div>
									</div>
								</div>
							</div>
							<div v-else-if="message.messageType == 1"
								:class="message.fromId == userid ? 'rightmessage' : 'leftmessage'">
								<div class="divimg"><img :src="message.avatar" alt="" /></div>
								<div class="divzt">{{message.off == 'true' ? '已读' : '未读'}}</div>
								<div class="divtext">
									<img style="width: 100px; height: 100px;" :src="message.extend.url" alt=""
										srcset="" />
								</div>
							</div>
							<div v-else-if="message.messageType == 5"
								:class="message.fromId == userid ? 'rightmessage' : 'leftmessage'">
								<div class="divimg"><img :src="message.avatar" alt="" /></div>
								<div class="divzt">{{message.off == 'true' ? '已读' : '未读'}}</div>
								<div class="divtext">
									<video controls style="width: 200px; height: 250px;">
										<source :src="message.extend.src" type="video/mp4">
									</video>
								</div>
							</div>
							<div v-else :class="message.fromId == userid ? 'rightmessage' : 'leftmessage'">
								<div class="divimg"><img :src="message.avatar" alt="" /></div>
								<div class="divzt">{{message.off == 'true' ? '已读' : '未读'}}</div>
								<div class="divtext">
									<img :src="giffn(message.content)" alt="" />
								</div>
							</div>
						</div>
					</div>
					<div class="input-box">
						<transition name="el-zoom-in-bottom">
							<div class="imgbox" v-show="isdisplay">
								<img @click="isdisplay = !isdisplay,clickimg(item.img)" v-for="item in gifarr"
									:key="item.id" :src="require(`../../../static/layui/images/face/` + item.img)"
									alt="" />
							</div>
						</transition>
						<div class="textimgdiv">
							<div @click="isdisplay = !isdisplay"><img src="../../assets/images/pc/xiaolian.png"
									alt="" /></div>
							<input @change="handleFileChange" style="display: none;" type="file" name="file"
								ref="files" />
							<div @click="shangchuanimgfn"><img src="../../assets/images/pc/tupian.png" alt="" /></div>
							<input @change="handleFileMP4Change" style="display: none;" type="file" name="file"
								ref="mp4files" />
							<div @click="shangchuanmp4fn"><img style="height: 28px; width: 30px;"
									src="../../assets/images/pc/shipin.png" alt="" /></div>
						</div>
						<!-- <div class="minicard" v-if="isshowminicard">
							<div class="left"><img :src="goodspart.image" alt="" /></div>
							<div class="right">
								<span>名称：<strong>{{goodspart.goodsname}}</strong></span>
								<span>价格：<strong style="color:#D33A31;">￥{{goodspart.price}}</strong></span>
								<span>订单号：{{goodspart.orderNumber}}</span>
								<div class="dianjifs" @click="onegoodschat">点击发送</div>
							</div>
						</div> -->
						<input type="text" v-model="messageText" @keydown.enter="addMessage(0,messageText)"
							placeholder="请输入消息内容">
						<button @click="addMessage(0,messageText)">发送</button>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
	import axios from 'axios'
	import {
		setImage,
		getoldmessage,
		getpresaleschatpoople
	} from '@/api/xunyou';
	import Vue from 'vue';
	export default {
		data() {
			return {
				leftMenu: [{
						id: 1,
						menu: '商城首页',
						url: '/',
						icon: 'el-icon-s-home'
					},
					{
						id: 2,
						menu: '用户中心',
						url: '/userCenter',
						icon: 'el-icon-user'
					},
					{
						id: 3,
						menu: '支付中心',
						url: '/paymentCenter',
						icon: 'el-icon-coin'
					},
				],
				type: this.$route.query.type,
				logo: '',
				userInfo: JSON.parse(localStorage.getItem("userdata")) || {},
				gifarr: [{
						"img": "0.gif",
						"id": 0
					},
					{
						"img": "1.gif",
						"id": 1
					},
					{
						"img": "2.gif",
						"id": 2
					},
					{
						"img": "3.gif",
						"id": 3
					},
					{
						"img": "4.gif",
						"id": 4
					},
					{
						"img": "5.gif",
						"id": 5
					},
					{
						"img": "6.gif",
						"id": 6
					},
					{
						"img": "7.gif",
						"id": 7
					},
					{
						"img": "8.gif",
						"id": 8
					},
					{
						"img": "9.gif",
						"id": 9
					},
					{
						"img": "10.gif",
						"id": 10
					},
					{
						"img": "11.gif",
						"id": 11
					},
					{
						"img": "12.gif",
						"id": 12
					},
					{
						"img": "13.gif",
						"id": 13
					},
					{
						"img": "14.gif",
						"id": 14
					},
					{
						"img": "15.gif",
						"id": 15
					},
					{
						"img": "16.gif",
						"id": 16
					},
					{
						"img": "17.gif",
						"id": 17
					},
					{
						"img": "18.gif",
						"id": 18
					},
					{
						"img": "19.gif",
						"id": 19
					},
					{
						"img": "21.gif",
						"id": 20
					},
					{
						"img": "22.gif",
						"id": 21
					},
					{
						"img": "23.gif",
						"id": 23
					},
					{
						"img": "24.gif",
						"id": 24
					},
					{
						"img": "25.gif",
						"id": 25
					},
					{
						"img": "26.gif",
						"id": 26
					},
					{
						"img": "27.gif",
						"id": 27
					},
					{
						"img": "28.gif",
						"id": 28
					},
					{
						"img": "29.gif",
						"id": 29
					},
					{
						"img": "30.gif",
						"id": 30
					},
					{
						"img": "31.gif",
						"id": 31
					},
					{
						"img": "32.gif",
						"id": 32
					},
					{
						"img": "33.gif",
						"id": 33
					},
					{
						"img": "34.gif",
						"id": 34
					},
					{
						"img": "35.gif",
						"id": 35
					},
					{
						"img": "36.gif",
						"id": 36
					},
					{
						"img": "37.gif",
						"id": 37
					},
					{
						"img": "38.gif",
						"id": 38
					},
					{
						"img": "39.gif",
						"id": 39
					},
					{
						"img": "40.gif",
						"id": 40
					},
				],
				// emojiMap: {
				// 	"微笑": "<img src='../../../static/layui/images/face/0.gif'/>",
				// 	"嘻嘻": "<img src='../../../static/layui/images/face/1.gif'/>",
				// 	"哈哈": "<img src='../../../static/layui/images/face/2.gif'/>",
				// 	"可爱": "<img src='../../../static/layui/images/face/3.gif'/>",
				// 	"可怜": "<img src='../../../static/layui/images/face/4.gif'/>",
				// 	"挖鼻": "<img src='../../../static/layui/images/face/5.gif'/>",
				// 	"吃惊": "<img src='../../../static/layui/images/face/6.gif'/>",
				// 	"害羞": "<img src='../../../static/layui/images/face/7.gif'/>",
				// 	"挤眼": "<img src='../../../static/layui/images/face/8.gif'/>",
				// 	"闭嘴": "<img src='../../../static/layui/images/face/9.gif'/>",
				// 	"鄙视": "<img src='../../../static/layui/images/face/10.gif'/>",
				// 	"爱你": "<img src='../../../static/layui/images/face/11.gif'/>",
				// 	"泪": "<img src='../../../static/layui/images/face/12.gif'/>",
				// 	"偷笑": "<img src='../../../static/layui/images/face/13.gif'/>",
				// 	"亲亲": "<img src='../../../static/layui/images/face/14.gif'/>",
				// 	"生病": "<img src='../../../static/layui/images/face/15.gif'/>",
				// 	"太开心": "<img src='../../../static/layui/images/face/16.gif'/>",
				// 	"白眼": "<img src='../../../static/layui/images/face/17.gif'/>",
				// 	"右哼哼": "<img src='../../../static/layui/images/face/18.gif'/>",
				// 	"左哼哼": "<img src='../../../static/layui/images/face/19.gif'/>",
				// 	"嘘": "<img src='../../../static/layui/images/face/20.gif'/>",
				// 	"衰": "<img src='../../../static/layui/images/face/21.gif'/>",
				// 	"委屈": "<img src='../../../static/layui/images/face/22.gif'/>",
				// 	"吐": "<img src='../../../static/layui/images/face/23.gif'/>",
				// 	"哈欠": "<img src='../../../static/layui/images/face/24.gif'/>",
				// },
				emojiMap: {
					"微笑": "<img src='https://www.nays.com.cn/center/profile/upload/2024/01/17/ebb0d566983e98b207de65928466724c.gif'/>",
					"嘻嘻": "<img src='https://www.nays.com.cn/center/profile/upload/2024/01/17/cfd6c724034619e463343bdd18ae2054.gif'/>",
					"哈哈": "<img src='https://www.nays.com.cn/center/profile/upload/2024/01/17/398e9cfe007561f3d843403eb5223fc3.gif'/>",
					"可爱": "<img src='https://www.nays.com.cn/center/profile/upload/2024/01/17/326dfc753bdabab5a1078d72aad8a831.gif'/>",
					"可怜": "<img src='https://www.nays.com.cn/center/profile/upload/2024/01/17/d0c3837063bbbfe04e1d61db168b5fa8.gif'/>",
					"挖鼻": "<img src='https://www.nays.com.cn/center/profile/upload/2024/01/17/6c71b664cd42b83830cf33ed75587cbf.gif'/>",
					"吃惊": "<img src='https://www.nays.com.cn/center/profile/upload/2024/01/17/4c1f8f268a7d5e34822cd91c261e9b33.gif'/>",
					"害羞": "<img src='https://www.nays.com.cn/center/profile/upload/2024/01/17/2f447e6e2e3b40449e878bc864e2b6b0.gif'/>",
					"挤眼": "<img src='https://www.nays.com.cn/center/profile/upload/2024/01/17/b21becfa700641dba951c13ade328b08.gif'/>",
					"闭嘴": "<img src='https://www.nays.com.cn/center/profile/upload/2024/01/17/4909784c09bb0d34af9ec6bee01366c3.gif'/>",
					"鄙视": "<img src='https://www.nays.com.cn/center/profile/upload/2024/01/17/05697b2d1b83b15dfcee51a138a29a9d.gif'/>",
					"爱你": "<img src='https://www.nays.com.cn/center/profile/upload/2024/01/17/47a9dd92fa80420b2ed1488602a94c0d.gif'/>",
					"泪": "<img src='https://www.nays.com.cn/center/profile/upload/2024/01/17/1679327e411f27f4a2547d989fe982cd.gif'/>",
					"偷笑": "<img src='https://www.nays.com.cn/center/profile/upload/2024/01/17/c4ad86f411946e1c3212484de93ff917.gif'/>",
					"亲亲": "<img src='https://www.nays.com.cn/center/profile/upload/2024/01/17/0310ff823298f496eda6e7bdaabff5ed.gif'/>",
					"生病": "<img src='https://www.nays.com.cn/center/profile/upload/2024/01/17/931ff97c7dd2d7cbfe6daa16438101a6.gif'/>",
					"太开心": "<img src='https://www.nays.com.cn/center/profile/upload/2024/01/17/4217bf643e720b630bfa7392fc04c94a.gif'/>",
					"白眼": "<img src='https://www.nays.com.cn/center/profile/upload/2024/01/17/11e6eb949ad17c9a6c9abdc26b3cdb5a.gif'/>",
					"右哼哼": "<img src='https://www.nays.com.cn/center/profile/upload/2024/01/17/8b0d7edd4bb6fb060a5c998cff3d19e0.gif'/>",
					"左哼哼": "<img src='https://www.nays.com.cn/center/profile/upload/2024/01/17/f521f84d27e2b177df3875ee6c9cecb2.gif'/>",
					"嘘": "<img src='https://www.nays.com.cn/center/profile/upload/2024/01/17/046f92526c6d5ca3c0381fd5033dfd2f.gif'/>",
					"衰": "<img src='https://www.nays.com.cn/center/profile/upload/2024/01/17/d8a903b5d37d761a8052e554ff8bb8ac.gif'/>",
					"委屈": "<img src='https://www.nays.com.cn/center/profile/upload/2024/01/17/60870d59c32d212b3b7fd6be178d8eba.gif'/>",
					"吐": "<img src='https://www.nays.com.cn/center/profile/upload/2024/01/17/14529d0d77475573031afb7eb1277864.gif'/>",
					"哈欠": "<img src='https://www.nays.com.cn/center/profile/upload/2024/01/17/af7466b790e90e12d217f489af44b8c6.gif'/>",
				},
				setInterval: null,
				kfname: null, // 客服名称
				loadingdialog: false, // loading效果
				// isshowminicard: true, // 小卡片的显示隐藏
				userid: null,
				id: localStorage.getItem('userdata'),
				socket: null,
				from: {}, // 收发人信息
				goodspart: {}, // 点击咨询时的小卡片信息
				isdisplay: false, // 是否显示发送表情模块
				messageText: '', // 聊天框内容
				messages: [], // 聊天所有数据
				dialogVisible: false,
			};
		},
		// 注册组件
		components: {

		},
		/**
		 * 数据发生改变
		 */

		/**
		 * 创建完毕
		 */
		created() {
			this.getImagelogo()
			this.ToChat()
			this.userid = JSON.parse(this.id).userId
		},
		mounted() {

		},
		destroyed() {
			this.socket.close(); //断开websocket连接
			clearInterval(this.setInterval)
		},
		/**
		 * 里面的方法只有被调用才会执行
		 */
		methods: {
			// 获取logo
			getImagelogo() {
				setImage().then((res) => {
					if (res.code == 0) {
						this.logo = res.rows[0].pcLogo;
					}
				});
			},
			// 点击上传图片
			shangchuanimgfn() {
				this.$refs.files.click()
			},
			// 选中图片状态改变
			handleFileChange(event) {
				const file = event.target.files[0];
				if (file) {
					// 执行图片上传的操作
					console.log('Selected file:', file.type);
					this.uploadFileimg(file);

				}
			},
			// 发图片
			uploadFileimg(file) {
				const formData = new FormData();
				formData.append('file', file);
				// console.log(`http://192.168.0.148:8080/api/common/upload/chatFile`);
				axios.post(`${Vue.prototype.$imUrl}/api/common/upload/chatFile`, formData, {
						headers: {
							'Content-Type': 'multipart/form-data'
						},
					})
					.then(res => {
						console.log('Upload successful 图片', res.data.url);
						if (res.data.url) {
							let url = {
								"url": res.data.url.toString()
							}
							this.addMessage(1, url)
						}
					})
					.catch(error => {
						console.error('Error uploading file 图片', error);
					});
			},


			// 点击上传视频
			shangchuanmp4fn() {
				this.$refs.mp4files.click()
			},
			// 选中视频状态改变
			handleFileMP4Change(event) {
				const file = event.target.files[0];
				if (file) {
					// 执行图片上传的操作
					console.log('Selected file:', file.type);
					this.uploadFileMP4(file);

				}
			},
			// 发视频
			uploadFileMP4(file) {
				const formData = new FormData();
				formData.append('file', file);
				// console.log(`http://192.168.0.148:8080/api/common/upload/chatFile`);
				axios.post(`${Vue.prototype.$imUrl}/api/common/upload/chatFile`, formData, {
						headers: {
							'Content-Type': 'multipart/form-data'
						},
					})
					.then(res => {
						console.log('Upload successful 视频', res.data.url);
						if (res.data.url) {
							let url = {
								"src": res.data.url.toString()
							}
							this.addMessage(5, url)
						}
					})
					.catch(error => {
						console.error('Error uploading file 视频', error);
					});
			},




			// 文字中的表情包
			textfaceimg(face) {
				let that = this
				// var text = "这是一段包含 face[微笑]、face[大笑] 和 face[开心] 的文字";
				var replacedText = face.replace(/face\[(.*?)\]/g, function(match, p1) {
					if (that.emojiMap[p1]) {
						return that.emojiMap[p1];
					} else {
						return match;
					}
				});
				return replacedText
			},
			// // 点击发送进行商品的发送,单商品咨询
			// onegoodschat() {
			// 	console.log("是否拿到orderNumber", this.goodspart);
			// 	this.addMessage(3, JSON.stringify(this.goodspart))
			// 	this.isshowminicard = false
			// 	this.goodspart = {}
			// },
			// 点击表情包
			clickimg(e) {
				this.addMessage(4, e)
			},
			// 判断是哪一个gif
			giffn(e) {
				console.log(e);
				return require(`../../../static/layui/images/face/${e}`)
			},
			// 点击发送信息
			addMessage(msgtype, content) {
				let fromlist = {}
				if (msgtype == 3) {
					fromlist = {
						code: "2",
						message: {
							chatId: this.from.fromId,
							chatType: this.type == "投诉系统" ? "2" : "1",
							extend: content,
							fromId: this.from.userId,
							messageType: msgtype + '', // 0文本， 1图片 2压缩包文件 3商品 4表情包
							mine: true,
							timestamp: new Date(),
							type: "0"
						}
					}
				} else if (msgtype == 1) {
					fromlist = {
						code: "2",
						message: {
							chatId: this.from.fromId,
							chatType: this.type == "投诉系统" ? "2" : "1",
							extend: content,
							fromId: this.from.userId,
							messageType: msgtype + '', // 0文本， 1图片 2压缩包文件 3商品 4表情包
							mine: true,
							timestamp: new Date(),
							type: "0"
						}
					}
				} else if (msgtype == 5) {
					fromlist = {
						code: "2",
						message: {
							chatId: this.from.fromId,
							chatType: this.type == "投诉系统" ? "2" : "1",
							extend: content,
							fromId: this.from.userId,
							messageType: msgtype + '', // 0文本， 1图片 2压缩包文件 3商品 4表情包 5视频
							mine: true,
							timestamp: new Date(),
							type: "0"
						}
					}
				} else {
					fromlist = {
						code: "2",
						message: {
							chatId: this.from.fromId,
							chatType: this.type == "投诉系统" ? "2" : "1",
							content: content,
							fromId: this.from.userId,
							messageType: msgtype + '', // 0文本， 1图片 2压缩包文件 3商品 4表情包
							mine: true,
							timestamp: new Date(),
							type: "0"
						}
					}
				}
				this.socket.send(JSON.stringify(fromlist));
				this.messageText = '';
				// console.log('点击发送了');
			},
			ToChat() {
				this.isdisplay = false // 关闭表情包窗口 
				// 获取收发人id
				getpresaleschatpoople(JSON.parse(this.id).userId, ).then((res) => {
					// 后端遗留问题 : 如果a客服休息一天,甲用户和b聊,那么a 上线时会和ab来回切换聊 bug
					console.log("双方id", res);
					if (res.code == 500) {
						this.$message.error(res.msg);
						return
					} else {
						this.kfname = res.data.name
						this.from = {
							userId: res.data.userId,
							fromId: res.data.fromId
						}
						// this.getoldmsg(res.data.userId, res.data.fromId)
						// this.socket.send(JSON.stringify({code: 1})); // 发送code1 用于获取缓存中的历史记录
						this.getoldmsg(this.from.userId, this.from.fromId) // 获取全部历史记录
					}
				})
				if (this.socket) return
				this.socket = new WebSocket(`${Vue.prototype.$wsUrl}/?token=${JSON.parse(this.id).userId}`);
				this.socket.onopen = () => {
					console.log('scoket链接成功!');
					this.setInterval = setInterval(() => {
						console.log('心跳开启');
						this.socket.send(JSON.stringify({
							code: 0
						}));
					}, 10000)
					this.socket.send(JSON.stringify({
						code: 1
					}));
				};
				
				this.socket.onclose = (event) => {
					if (event.wasClean) {
						console.log(`scoket关闭, code=${event.code} reason=${event.reason}`);
					} else {
						// 例如服务器进程被杀死或网络中断
						// 在这种情况下，event.code 通常为 1006
					}
				};

				this.socket.onerror = (error) => {
					console.log(`scoket异常 ${error.message}`);
				};


				this.socket.onmessage = (event) => {
					console.log(`收到消息: ${event.data}`);
					// console.log('转换完了', JSON.parse(event.data).message.content);
					// console.log("code为:", JSON.parse(event.data).code);
					if (JSON.parse(event.data).code == 0) {
						console.log("停止");
						return
					}
					if (JSON.parse(event.data).code == 4) {
						this.$message({
							message: '客服已转接!',
							type: 'success'
						});
						this.kfname = JSON.parse(event.data).message.name
						this.from.fromId = JSON.parse(event.data).message.chatId.toString() // 新客服id
						if (true) {
							this.$message({
								message: '自动发一条信息!',
								type: 'success'
							});
							this.messageText = "----聊天状态已改变,请注意查收新消息!----"
							this.addMessage(0, JSON.stringify(this.messageText))
						}
					}
					if (JSON.parse(event.data).code == 5) {
						// this.$message({
						// 	message: '客服已读!',
						// 	type: 'success'
						// });
						this.messages.forEach(item => {
							item.readState = 'true'
						})
					}
					if (JSON.parse(event.data).message.messageType == 0) {
						this.messages.push({
							readState: '',
							messageType: JSON.parse(event.data).message.messageType,
							content: JSON.parse(event.data).message.content,
							fromId: JSON.parse(event.data).message.fromId + '',
							avatar: JSON.parse(event.data).message.fromId + '' == this.userid ? JSON.parse(this
									.id).avatar :
								'https://tse1-mm.cn.bing.net/th/id/OIP-C.1t2MobIQJZnthL-k7lBZEgAAAA?pid=ImgDet&rs=1'
						});
						// console.log("文字push成功");
					} else if (JSON.parse(event.data).message.messageType == 3) {
						this.messages.push({
							readState: '',
							messageType: JSON.parse(event.data).message.messageType,
							extend: JSON.parse(JSON.parse(event.data).message.extend),
							fromId: JSON.parse(event.data).message.fromId + '',
							avatar: JSON.parse(event.data).message.fromId + '' == this.userid ? JSON.parse(this
									.id).avatar :
								'https://tse1-mm.cn.bing.net/th/id/OIP-C.1t2MobIQJZnthL-k7lBZEgAAAA?pid=ImgDet&rs=1'
						});
						console.log("卡片信息", {
							readState: '',
							messageType: JSON.parse(event.data).message.messageType,
							extend: JSON.parse(JSON.parse(event.data).message.extend),
							fromId: JSON.parse(event.data).message.fromId + '',
							avatar: JSON.parse(event.data).message.fromId + '' == this.userid ? JSON.parse(this
									.id).avatar :
								'https://tse1-mm.cn.bing.net/th/id/OIP-C.1t2MobIQJZnthL-k7lBZEgAAAA?pid=ImgDet&rs=1'
						});
						// console.log("卡片push成功");
					} else if (JSON.parse(event.data).message.messageType == 1) {
						this.messages.push({
							readState: '',
							messageType: JSON.parse(event.data).message.messageType,
							extend: JSON.parse(event.data).message.extend,
							fromId: JSON.parse(event.data).message.fromId + '',
							avatar: JSON.parse(event.data).message.fromId + '' == this.userid ? JSON.parse(this
									.id).avatar :
								'https://tse1-mm.cn.bing.net/th/id/OIP-C.1t2MobIQJZnthL-k7lBZEgAAAA?pid=ImgDet&rs=1'
						});
						// console.log("图片push成功");
					} else if (JSON.parse(event.data).message.messageType == 5) {
						this.messages.push({
							readState: '',
							messageType: JSON.parse(event.data).message.messageType,
							extend: JSON.parse(event.data).message.extend,
							fromId: JSON.parse(event.data).message.fromId + '',
							avatar: JSON.parse(event.data).message.fromId + '' == this.userid ? JSON.parse(this
									.id).avatar :
								'https://tse1-mm.cn.bing.net/th/id/OIP-C.1t2MobIQJZnthL-k7lBZEgAAAA?pid=ImgDet&rs=1'
						});
						// console.log("视频push成功");
					} else if (JSON.parse(event.data).message.messageType == 4) {
						this.messages.push({
							readState: '',
							messageType: JSON.parse(event.data).message.messageType,
							content: JSON.parse(event.data).message.content,
							fromId: JSON.parse(event.data).message.fromId + '',
							avatar: JSON.parse(event.data).message.fromId + '' == this.userid ? JSON.parse(this
									.id).avatar :
								'https://tse1-mm.cn.bing.net/th/id/OIP-C.1t2MobIQJZnthL-k7lBZEgAAAA?pid=ImgDet&rs=1'
						});
						// console.log("表情包push成功");
					}
					this.$nextTick(() => {
						let scrollElem = document.getElementById('message-list');
						scrollElem.scrollTo({
							top: scrollElem.scrollHeight,
							behavior: 'smooth'
						});
					});
				};
				setInterval(() => {
					this.isshowminicard = false
				}, 8000)
			},
			// 获取聊天记录
			getoldmsg(u, c) {
				// console.log("进入了历史记录:",u, c);
				const page = {
					chatId: c, // 客服id
					fromId: u, // 用户id
					chatType: "0", // 0是单聊
					messageType: " ", // 不传为获取所以类型的历史记录
					current: "1",
					size: "40"
				}
				this.loadingdialog = true // 开启loading
				getoldmessage(page).then((res) => {
					console.log("ressss", res);
					// this.messages = [...res.data.records].reverse()
					this.messages = [...res.data]
					this.$nextTick(() => {
						let msg = document.getElementById('message-list') // 获取对象
						msg.scrollTop = msg.scrollHeight // 滚动高度
					})
					this.loadingdialog = false // 关闭loading
				}).catch((req) => {
					console.log("错误信息", req);
				})
			},
		},
	};
</script>

<style scoped lang="less">
	.header_logo {
		height: 100%;

		.xunyouText {
			width: 100px;
			max-height: 60px;
		}

		li.el-menu-item {
			color: white !important;
			font-size: 16px;

			i {
				color: white;
				vertical-align: inherit;
			}
		}

		.middle {
			height: 100% !important;
			// background: url("~@/assets/img/userCenterbg.jpg") no-repeat;
			background-repeat: no-repeat;
			background-size: cover;
			// background: #fff;
		}

	}

	.breakcrumbHeader {
		margin: 15px 0;
	}

	.dialogContent {
		width: 1200px;
		height: 700px;
		margin: 0 auto;
		margin-top: 50px;
	}

	/deep/.el-dialog__body {
		padding: 10px 5px !important;
		color: #606266;
		font-size: 14px;
		word-break: break-all;
	}

	.chat-box {
		display: flex;
		flex-direction: column;
		height: 100%;
		width: 100%;
		margin: 0 auto;
		border: 0px;
	}

	#message-list {
		flex: 1;
		overflow-y: auto;
	}

	.leftmessage {
		display: flex;
		flex-direction: column;
		margin: 4px 0;
		width: 100%;
		min-height: 50px;
		font-size: 14px;
		position: relative;

		.divtext {
			padding: 0 50px;
		}

		.divimg {
			height: 30px;
			padding: 0 15px;

			img {
				width: 30px;
				height: 30px;
			}
		}

		.divzt {
			position: absolute;
			color: #ccc;
			top: -5px;
			left: 50px;
		}


	}

	.rightmessage {
		display: flex;
		flex-direction: column;
		position: relative;
		margin: 4px 0;
		width: 100%;
		font-size: 14px;


		.divtext {
			padding: 0 50px;
			display: flex;
			justify-content: end;

			.minicard {
				padding-bottom: 15px;
				margin-right: 15px;
				width: 250px;
				height: 110px;
				background-color: #f1f1f1;
				border-radius: 8px;
				padding: 5px;
				display: flex;

				.left {
					flex: 1.5;
					background-color: #c4ffee;

					img {
						width: 100%;
						height: 100%;
					}
				}

				.right {
					flex: 2;
					position: relative;

					.dianjifs {
						line-height: 25px;
						text-align: center;
						color: #dcdfe6;
						width: 75px;
						height: 25px;
						border-radius: 20px;
						background-color: #D33A31;
						transform: translateX(-50%);
						cursor: pointer;
					}

					span {
						font-size: 14px;
						transform: scale(0.8);
						overflow: hidden;
						text-overflow: ellipsis;
						display: -webkit-box;
						-webkit-box-orient: vertical;
						-webkit-line-clamp: 2;
					}
				}


			}
		}

		.divimg {
			height: 30px;
			padding: 0 15px;
			display: flex;
			justify-content: end;

			img {
				width: 30px;
				height: 30px;
			}
		}

		.divzt {
			position: absolute;
			color: #ccc;
			top: -5px;
			right: 50px;
		}

	}

	.message-text {
		font-size: 14px;
	}

	.input-box {
		display: flex;
		flex-direction: row;
		justify-content: space-between;
		padding: 10px;
		border-top: 1px solid #ccc;
		position: relative;

		.imgbox {
			background-color: #eeeeee;
			width: 202px;
			height: 145px;
			position: absolute;
			top: -160px;
			left: 10px;
			border-radius: 5px;
			padding: 5px;
			box-sizing: border-box;
			overflow-y: auto;

			&::-webkit-scrollbar {
				display: none;
			}

			img {
				cursor: pointer;
				margin: 6px 5px;
			}
		}

		.minicard {
			width: 250px;
			height: 110px;
			background-color: #e7e7e7;
			border-radius: 8px;
			padding: 5px;
			position: absolute;
			top: -130px;
			right: 10px;
			display: flex;

			.left {
				flex: 1.5;
				background-color: #c4ffee;

				img {
					width: 100%;
					height: 100%;
				}
			}

			.right {
				flex: 2;
				position: relative;

				.dianjifs {
					line-height: 25px;
					text-align: center;
					color: #dcdfe6;
					width: 75px;
					height: 25px;
					border-radius: 20px;
					background-color: #D33A31;
					position: absolute;
					bottom: 5px;
					left: 50%;
					transform: translateX(-50%);
					cursor: pointer;
				}

				span {
					font-size: 14px;
					transform: scale(0.8);
					overflow: hidden;
					text-overflow: ellipsis;
					display: -webkit-box;
					-webkit-box-orient: vertical;
					-webkit-line-clamp: 2;
				}
			}

		}

		.textimgdiv {
			width: 100px;
			height: 30px;
			background-color: #ffffff;
			position: absolute;
			top: 0;
			left: 0;
			display: flex;
			// justify-content: space-around;
			justify-content: start;
			line-height: 25px;
			text-align: center;

			div {
				width: 40px;

				img {
					width: 20px;
					height: 20px;
					cursor: pointer;
				}
			}
		}
	}

	.input-box input {
		flex: 1;
		margin-right: 10px;
		padding: 25px 10px 0 10px;
		font-size: 14px;
		border-radius: 5px;
		border: none;
		outline: none;
	}

	.input-box button {
		padding: 6px 20px;
		font-size: 14px;
		font-weight: bold;
		border-radius: 5px;
		background-color: #d33a31;
		color: #fff;
		border: none;
		cursor: pointer;
		transition: background-color 0.3s;
	}

	.input-box button:hover {
		background-color: #d33a31;
	}
</style>


// WEBPACK FOOTER //
// src/views/consultationandComplaints/index.vue